
export interface Synchronization {
    id: string;
    customerId: number;
    companyId: number;
    name: string;
    enabled: boolean;
    activated: string | null;
    key: string;
    changed: string;
    customerName: string;
    companyName: string;
    departmentId: string;
    departmentCode: string;

    // Kun admin
    externalKey: string;
    externalKeyClearText: string;

}

export interface CreateSynchronizationContract {
    customerId: number;
    companyId: number;
    name: string;
    departmentId: string;
}

export interface Company {
    companyId: number;
    name: string;
    nameUrl: string;
    // ui helpers
    isEditing: boolean;
    isChanged: boolean;
    isSaving: boolean;
    // temp value
    tempName: string;
}

export enum QStatus {
    None = 0,
    Waiting = 10,
    Paused = 20,
    Validating = 30,
    ValidatingData = 32,
    Queued = 35,
    Executing = 40,
    PrepareExecute = 42,
    ReadDataExecute = 44,
    SyncDataExecute = 46,
    PreSynchronizationQueued = 50,
    PreSynchronizationPrepare = 51,
    PreSynchronizationExecute = 52,
    PostSynchronizationQueued = 60,
    PostSynchronizationPrepare = 61,
    PostSynchronizationExecute = 62,
    Done = 150,
    DoneWithErrors = 152,
    DoneWithWarnings = 154,
    Warnings = 160,
    Failed = 170,
    SystemFailed = 171,
    Cancelled = 180
}

export enum LogSeverity {
    Trace = 0,
    Debug = 1,
    Information = 2,
    Warning = 3,
    Error = 4,
    Critical = 5,
    None = 6
}

export type QueueStatusGroup = 'all' | 'running' | 'finished' | 'warning' | 'failed';
